var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleGreenUnfilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19869_208878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6866 6.68705C10.8818 6.49179 10.8818 6.1752 10.6866 5.97994C10.4913 5.78468 10.1747 5.78468 9.97945 5.97994L6.99967 8.95972L6.01989 7.97994C5.82463 7.78468 5.50805 7.78468 5.31279 7.97994C5.11753 8.17521 5.11753 8.49179 5.31279 8.68705L6.64612 10.0204C6.84138 10.2156 7.15797 10.2156 7.35323 10.0204L10.6866 6.68705Z",
    fill: "#06AD00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99967 0.833496C4.04163 0.833496 0.833008 4.04212 0.833008 8.00016C0.833008 11.9582 4.04163 15.1668 7.99967 15.1668C11.9577 15.1668 15.1663 11.9582 15.1663 8.00016C15.1663 4.04212 11.9577 0.833496 7.99967 0.833496ZM1.83301 8.00016C1.83301 4.59441 4.59392 1.8335 7.99967 1.8335C11.4054 1.8335 14.1663 4.59441 14.1663 8.00016C14.1663 11.4059 11.4054 14.1668 7.99967 14.1668C4.59392 14.1668 1.83301 11.4059 1.83301 8.00016Z",
    fill: "#06AD00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19869_208878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleGreenUnfilled);
export default __webpack_public_path__ + "static/media/checkCircleGreenUnfilled.96dbb2cfef9aa020b41dd25471dcbdc4.svg";
export { ForwardRef as ReactComponent };